import styled from "styled-components";
import { Container } from "./style";

import Slider from "./slider.png"

import { useTranslation } from 'react-i18next';

import StatisticsNavigation from "./StatisticComponents";


import "./main.css"
import { Link } from "react-router-dom";





const AppStyled = styled.div`

`

const Content = styled.div`
padding: 20px 0;
background-color: #F5F5F4;
`

function Main() {
  const { t } = useTranslation();

  return (
    <AppStyled>
      {/* <img src={Slider} style={{ width: "100%" }} /> */}
      <Content>
        <Container>
          <div className="page">
            <div className="column">
              {/* Exchange Rates Section */}
              <section className="section">
                <h2 className="section__title">{t('dashboard.exchangeRates.title')}</h2>
                <div className="rates-grid">
                  {Object.entries({
                    usdTjs: '9.9141',
                    eurTjs: '11.3219',
                    rubTjs: '0.1250',
                    cnyTjs: '1.3748'
                  }).map(([key, value]) => (
                    <div className="rates-item" key={key}>
                      <div className="rates-item__label">
                        {t(`dashboard.exchangeRates.pairs.${key}`)}
                      </div>
                      <div className="rates-item__value">{value}</div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Gold Rate Section */}
              <section className="section">
                <h2 className="section__title">{t('dashboard.goldRate.title')}</h2>
                <div className="rates-grid">
                  <div className="rates-item">
                    <div className="rates-item__label">{t('dashboard.goldRate.buy')}</div>
                    <div className="rates-item__value">108147.55		/ 100 гр</div>
                  </div>
                  <div className="rates-item">
                    <div className="rates-item__label">{t('dashboard.goldRate.sell')}</div>
                    <div className="rates-item__value">106006.01 / 100 гр</div>
                  </div>
                </div>
              </section>

              {/* Economic Indicators Section */}
              <section className="section">
                <h2 className="section__title">{t('dashboard.economicIndicators.title')}</h2>
                {[
                  { key: 'gdp', value: '0,4%' },
                  { key: 'inflation', value: '3,7%' },
                  { key: 'unemployment', value: '47,8' }
                ].map(({ key, value }) => (
                  <div className="rates-item" key={key}>
                    <div className="rates-item__label">
                      {t(`dashboard.economicIndicators.${key}`)}
                    </div>
                    <div className="rates-item__value">{value}</div>
                  </div>
                ))}
              </section>

              {/* Monetary Policy Section */}
              {/* <section className="section">
                <h2 className="section__title">{t('dashboard.monetaryPolicy.title')}</h2>
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t('dashboard.monetaryPolicy.table.header.indicator')}</th>
                      <th>{t('dashboard.monetaryPolicy.table.header.rate')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { key: 'keyRate', value: '11.5' },
                      { key: 'overnight', value: '12.5' },
                      { key: 'deposit', value: '9.5' }
                    ].map(({ key, value }) => (
                      <tr key={key}>
                        <td>{t(`dashboard.monetaryPolicy.table.rows.${key}`)}</td>
                        <td>{value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section> */}
            </div>

            <div className="column">

              <section className="section">
                <h2 className="section__title">{t('dashboard.keyEvents.title')}</h2>
                <Link to="news17">
                  <div className="news-item">
                    <div className="news-item__date">15.04.2025</div>
                    <div className="news-item__text">
                      {t('news17.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news16">
                  <div className="news-item">
                    <div className="news-item__date">03.04.2025</div>
                    <div className="news-item__text">
                      {t('news16.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news15">
                  <div className="news-item">
                    <div className="news-item__date">21.03.2025</div>
                    <div className="news-item__text">
                      {t('news15.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news13">
                  <div className="news-item">
                    <div className="news-item__date">18.03.2025</div>
                    <div className="news-item__text">
                      {t('news13.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news14">
                  <div className="news-item">
                    <div className="news-item__date">08.03.2025</div>
                    <div className="news-item__text">
                      {t('news14.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news12">
                  <div className="news-item">
                    <div className="news-item__date">21.02.2025</div>
                    <div className="news-item__text">
                      {t('news12.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news11">
                  <div className="news-item">
                    <div className="news-item__date">19.02.2025</div>
                    <div className="news-item__text">
                      {t('news11.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news10">
                  <div className="news-item">
                    <div className="news-item__date">11.02.2025</div>
                    <div className="news-item__text">
                      {t('news10.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news9">
                  <div className="news-item">
                    <div className="news-item__date">11.02.2025</div>
                    <div className="news-item__text">
                      {t('news9.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news8">
                  <div className="news-item">
                    <div className="news-item__date">07.02.2025</div>
                    <div className="news-item__text">
                      {t('news8.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news7">
                  <div className="news-item">
                    <div className="news-item__date">05.02.2025</div>
                    <div className="news-item__text">
                      {t('news7.title')}
                    </div>
                  </div>
                </Link>
                <Link to="news6">
                  <div className="news-item">
                    <div className="news-item__date">05.02.2025</div>
                    <div className="news-item__text">
                      {t('news6.title')}
                    </div>
                  </div>
                </Link>
                {/* <Link to="news5">
                  <div className="news-item">
                    <div className="news-item__date">15.01.2025</div>
                    <div className="news-item__text">
                    {t('news5.title')}
                    </div>
                  </div>
                </Link>
           
                <Link to="news3">
                  <div className="news-item">
                    <div className="news-item__date">09.01.2025</div>
                    <div className="news-item__text">
                    {t('dashboard.keyEvents.events.news3')}
                    </div>
                  </div>
                </Link>
                <Link to="news4">
                  <div className="news-item">
                    <div className="news-item__date">30.12.2024</div>
                    <div className="news-item__text">
                    {t('dashboard.keyEvents.events.news4')}
                    </div>
                  </div>
                </Link> */}
                {/* <Link to="news1">
                  <div className="news-item">
                    <div className="news-item__date">12.12.2024</div>
                    <div className="news-item__text">
                      {t('dashboard.keyEvents.events.womenEmpowerment')}
                    </div>
                  </div>
                </Link>
                <Link to="news2">
                  <div className="news-item">
                    <div className="news-item__date">27.12.2024</div>
                    <div className="news-item__text">
                      {t('dashboard.keyEvents.events.digitalMemorandum')}
                    </div>
                  </div>
                </Link> */}
              </section>
            </div>

            <div className="column">
              {/* President Section */}
              <section className="section">
                <img
                  src="https://nbt.tj/upload/prezident.jpg"
                  alt={t('dashboard.president.name')}
                  className="president__image"
                />
                <h3 className="president__name">{t('dashboard.president.name')}</h3>
                <div className="president__content">
                  <p>{t('dashboard.president.quote')}</p>
                </div>
              </section>

              {/* Interest Rates Section */}
              {/* <section className="section">
                <h2 className="section__title">{t('dashboard.interestRates.title')}</h2>
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t('dashboard.interestRates.table.header.quarter')}</th>
                      <th>{t('dashboard.interestRates.table.header.rate')}</th>
                      <th>{t('dashboard.interestRates.table.header.change')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { q: 'q1', rate: '11.5', change: '-0.25' },
                      { q: 'q2', rate: '11.0', change: '-0.5' },
                      { q: 'q3', rate: '10.5', change: '-0.5' },
                      { q: 'q4', rate: '10.0', change: '-0.5' }
                    ].map(({ q, rate, change }) => (
                      <tr key={q}>
                        <td>{t(`dashboard.interestRates.table.quarters.${q}`)}</td>
                        <td>{rate}</td>
                        <td>{change}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section> */}
            </div>
          </div>
        </Container>
      </Content>
      <StatisticsNavigation />
      <br />
    </AppStyled>
  );
}

export default Main;
